import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm, Controller } from "react-hook-form";
import { FaCalendarAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import { number } from "yup";
import api from "../../../../utils/api";
import { IoInformationCircleOutline } from "react-icons/io5";
import FundDetailsModal from "../../PortfolioReview/FundDetailsModal";

const SectionHeader = ({ title }) => (
  <h6
    className="text-center mb-4 text-white py-2 fw-normal"
    style={{
      backgroundColor: "#23674B",
      borderRadius: "10px",
    }}
  >
    {title}
  </h6>
);

const AddNewInvestments = ({
  show,
  onHide,
  onSave,
  roomId,
  isClientData,
  selectedCard,
  isFiltered,
  setSIPSuccess,
  setDefSIP,
  defSIP,
  getDraftGoalData,
  currentMaritulStatus,
  isGetClientGoal
}) => {


  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
    control,
  } = useForm();
  // console.log("isFiltered",isFiltered);
  const sipStartDatePickerRef = useRef();
  const stpStartDatePickerRef = useRef();
  const endDatePickerRef = useRef();
  const [isLabel, setIsLabel] = useState("");
  const [actionName, setActionName] = useState("");

  const [subGoalId, setSubGoalId] = useState(null);
  const [subGoalName, setSubGaolName] = useState(null);




  const [amcName, setAmcFundList] = useState([]);
  // const dd = watch('investorName')
  // console.log("investorName",dd,isClientData);
  const [isLoadingAMC, setIsLoadingAMC] = useState(false);
  const [amcNameList, setAmcNameList] = useState([]);
  // console.log('amcNameList',amcNameList);

  const [deficitAmount, setDeficitAmount] = useState(0);
  const [investString, setInvestString] = useState([
    "Invest",
    " ₹",
    " in Fund",
  ]);
  const [stepUpImpact, setStepUpImpact] = useState(0);

  const [sipAmountError, setSipAmountError] = useState("");
  const [lumpSumAmountError, setLumpSumAmountError] = useState("");
  const [stpFreqError, setStpFreqError] = useState("");
  const [stpDurationError, setStpDurationError] = useState("");
  const [stpLumpsumAmountError, setStpLumpsumAmountError] = useState("");
  const [stpInFundError, setStpInFundError] = useState("");
  const [stpError, setSTPError] = useState("");

  const [sipAllowedDate, setSipAllowedDate] = useState('');
  const [stpFrequencyAllowed, setSTPFrequencyAllowed] = useState('');

  console.log('sipAllowedDate', sipAllowedDate, stpFrequencyAllowed);

  const [isSelectedFundOption, setSelectedFundOption] = useState({});

  const [bankDetails, setBankDetails] = useState([]);

  const [isError, setIsError] = useState("");
  const [userConfirmed, setUserConfirmed] = useState();

  const selectedInvestorName = watch("investorName");
  const dataString = selectedInvestorName;
  const values = dataString?.split("|");
  const mandateStatus = values?.[11]?.trim();
  const IFSCCode = values?.[12]?.trim();

  // console.log('bankDetails',selectedInvestorName,mandateStatus);

  const selectedSTP = watch("stp");

  const selectedInvest = watch("invest");
  const inputSIPAmount = watch("sipAmount");
  const selectedFund = watch("investmentType");
  const selectedSubFundName = watch("fundName");
  const selectedSipStartDate = watch("sipStartDate");
  const selectedSipEndDate = watch("sipEndDate");
  const selectedPrepetualType = watch("prepetualSIP");
  const selectedAnnualStepUp = watch("annualStepUp");
  const selectedAnnualStepUpAmount = watch("stepUpAmount");

  const inputLumpSumAmount = watch("lumpSumAmount");
  const inputStp = watch("stp");
  const inputStpFreq = watch("stpFrequency");
  const inputStpDuration = watch("stpDuration");
  const inputStpLumpsumAmount = watch("stplumpSumAmount");
  const inputStpFund = watch("stpfundName");
  console.log("selectedInvest", selectedInvest);



  useEffect(() => {
    // education
    if (selectedCard && selectedCard?._id == '66d028759a75443e96fd3412') {
      const newGoalId = selectedCard?.action_data[0]?._id;
      setSubGoalId(newGoalId);

      let childId = selectedCard?.action_data[0]?.childId

      const fchild = isClientData?.children?.find(child => child._id.toString() == childId.toString());
      let childName = fchild?.name.split(' ')[0];
      let subGoalName = childName + '`s ' + selectedCard?.action_data[0]?.maritalStatus
      setSubGaolName(subGoalName);


      // marrige
    } else if (selectedCard && selectedCard?._id == '66d0280c9a75443e96fd3411') {

      const newGoalId = selectedCard?.action_data[0]?._id;
      setSubGoalId(newGoalId);

      let childId = selectedCard?.action_data[0]?.childId

      const fchild = isClientData.children.find(child => child._id.toString() == childId.toString());
      let childName = fchild.name.split(' ')[0];
      let subGoalName = childName + '`s Marrige';
      setSubGaolName(subGoalName);
    } else {
      setSubGaolName(selectedCard?.text)

    }



  }, [selectedCard, isClientData]);


  useEffect(() => {
    setValue("stplumpSumAmount", inputLumpSumAmount);
  }, [inputLumpSumAmount, setValue]);

  useEffect(() => {
    setValue("stpfundName", "");
  }, [selectedSubFundName, amcNameList, setValue]);

  // console.log("selectedSubFundName", selectedSubFundName);

  useEffect(() => {
    if (selectedPrepetualType === "Yes") {
      setValue("sipEndDate", "");
    }
  }, [selectedPrepetualType, setValue]);



  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const preGoalName = 'test....'
  // const preGoalDetails = isPortfolioData?.goaldeatils?.[openSipFormAllData?.goalId];
  const preGoalDetails = {
    goalYear: new Date(),
    startyear: new Date(),
  }
  const showFundDetails = async (fundName, goalName) => {
    setShowModal(true);
    try {
      const res = await api.post(
        `advisor/get_fund_by_name`,
        {
          fund_name: fundName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data;

      if (!data || data.length === 0) return;

      const fund = data;

      if (
        fund.Whitelisted !== "true" ||
        fund.Time_Horizon === "Temporary Parking"
      ) {
        const errorMsg =
          fund.Whitelisted === "false"
            ? "Fund snapshots are only available for whitelisted funds"
            : "Fund Snapshots not available for Temporary Parking Funds";
        setModalContent(
          `<p class="text-danger text-center mt-3">${errorMsg}</p>`
        );
        return;
      }

      const currentYear = new Date().getFullYear();
      const goalDuration = preGoalDetails?.goalYear - preGoalDetails?.startyear;
      let rtn2 =
        goalDuration <= 1
          ? "6 %"
          : goalDuration <= 3
            ? "8 %"
            : goalDuration <= 4.99
              ? "10 %"
              : goalDuration <= 6.99
                ? "12 %"
                : "14 %";

      let stmt2 = "";
      let rtnText = "";
      switch (fund.Time_Horizon) {
        case "1-3 Years":
          rtnText = "3 YEAR RETURN";
          stmt2 = "Short term focus is capital protection.";
          break;
        case "3-5 Years":
          rtnText = "5 YEAR RETURN";
          stmt2 = "Staggered entries work well here.";
          break;
        case "Above 5 Years":
          rtnText = "10 YEAR RETURN";
          // stmt2 = "Invest monthly through SIPs or STPs.";
          stmt2= " A staggered approach through SIPs or STPs can help manage risk and enable disciplined investing and compounding over time.";

          break;
      }

      let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

      if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
      console.log("response 12 h", fund);

      const goalName2 = ["marriage", "graduation"].some((g) =>
        preGoalName?.toLowerCase().includes(g)
      )
        ? preGoalName
        : "Your " + preGoalName;
      console.log("response 12 g", fund);

      let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
      riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

      const html = `
        <div style="max-height: 600px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
          <div class="row">
            <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
            <div class="col-sm-8 text-dark pt-3 text-center">
              <div style="font-size:1.7vw;"><strong>${preGoalName} | Year ${preGoalDetails?.goalYear
        }</strong></div>
              <div style="font-size: 1.3vw;">${fund.fund_name}</div>
            </div>
          </div><br>
          <div class="row text-center mb-3">
            <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
        }</span></div>
            <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
        }</span></div>
            <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
          </div>
          <div class="row d-flex justify-content-between text-center mb-3">
            <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
        }</span></div>
            <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-8">
              <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
                <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
                <ul class="small mt-2 ms-3 text-justify">
                  ${[
          fund.rationale1,
          fund.rationale2,
          fund.rationale3,
          fund.rationale4,
          fund.rationale5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                </ul>
              </div>
            </div>
            <div class="col-sm-4">
              <span class="fs-5 fw-bold text-success">SUMMARY</span>
              <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
              <hr>
            <p style="font-size: 1vw;">Your ${goalName2} is  ${preGoalDetails?.goalYear - currentYear
        } years away, and hence, we recommend  ${riskProfile} fund like ${fundName} to benefit from its long-term growth potential.${stmt2}</p>
              </div>
          </div>
          <div>
          <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
          <ul class="small mt-2 ms-3 text-justify text-dark">
                  ${[
          fund.philosophy1,
          fund.philosophy2,
          fund.philosophy3,
          fund.philosophy4,
          fund.philosophy5,
        ]
          .map((r) => `<li>${r}</li>`)
          .join("")}
                </ul>
          </div>
        </div>
      `;

      setModalContent(html);
    } catch (err) {
      console.error(err);
      setModalContent(
        `<p class="text-danger text-center mt-3">Something went wrong</p>`
      );
    }
  };



  useEffect(() => {
    let jsxLabel = null;

    if (selectedInvest === "SIP") {
      jsxLabel = (
        <div>
          {`Start a Monthly ${selectedInvest}`}

          {inputSIPAmount && (
            <>
              {` of ₹${inputSIPAmount}`}
              {selectedSubFundName && (
                <>
                  {" into "}
                  {selectedSubFundName}
                  {/* <IoInformationCircleOutline
                    className="ms-2"
                    onClick={() => showFundDetails(selectedSubFundName)}
                    style={{ cursor: "pointer" }}
                  /> */}
                </>
              )}
              {selectedAnnualStepUpAmount && (
                <span>{` with an Annual Step Up of ₹${selectedAnnualStepUpAmount}`}</span>
              )}
            </>
          )}
        </div>
      );
    } else if (selectedInvest === "Lump Sum") {
      jsxLabel = (
        <div>
          {`Invest ${selectedInvest}`}
          {inputLumpSumAmount && (
            <>
              {` of ₹${inputLumpSumAmount}`}
              {selectedSubFundName && (
                <>
                  {" in "}
                  {selectedSubFundName}
                </>
              )}

              {inputStpFreq && (
                <>
                  {`. Start a ${inputStpFreq} STP`}
                  {inputStpDuration && (
                    <>
                      {inputStpFreq === "Monthly" && (
                        <span>
                          {` of ₹${(inputLumpSumAmount / inputStpDuration).toFixed(
                            0
                          )} for ${inputStpDuration} months`}
                        </span>
                      )}
                      {inputStpFreq === "Weekly" && (
                        <span>
                          {` of ₹${(
                            inputLumpSumAmount /
                            (inputStpDuration * 4)
                          ).toFixed(0)} for ${inputStpDuration} months`}
                        </span>
                      )}
                      {inputStpFund && (
                        <>
                          {" into "}
                          {inputStpFund}
                          {/* <IoInformationCircleOutline
                            className="ms-2"
                            onClick={() => showFundDetails(inputStpFund)}
                            style={{ cursor: "pointer" }}
                          /> */}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      );
    }

    setActionName(jsxLabel); // ✅ ab string ke bajay JSX set hoga
  }, [
    selectedInvest,
    inputSIPAmount,
    inputLumpSumAmount,
    selectedSubFundName,
    selectedAnnualStepUpAmount,
    inputStpFreq,
    inputStpDuration,
    inputStpFund,
  ]);

  useEffect(() => {
    getInvestor();
  }, []);

  // Fetch Investor Name fund list from API
  const getInvestor = async () => {
    try {
      const response = await api.get(
        `advisor/allHouseholdUcc/${roomId}`
      );
      setBankDetails(response.data);

      // console.log("BankDetails", response.data);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    }
  };

  useEffect(() => {
    if (isSelectedFundOption && selectedInvest === "SIP" && inputSIPAmount) {
      const minSIP = isSelectedFundOption?.BSE_Minimum_SIP_Amount;
      const maxSIP = isSelectedFundOption?.BSE_Maximum_SIP_Amount;
      const sipDeficit = checkSIPAllowed(defSIP);
      console.log('defSIP', defSIP)
      if (inputSIPAmount < Number(minSIP)) {
        setSipAmountError(
          `Minimum SIP amount allowed for the selected fund is ₹${minSIP}`
        );
      } else if (inputSIPAmount > Number(maxSIP)) {

        if (maxSIP === '' || maxSIP === 0 || maxSIP === null || maxSIP === undefined) return
        setSipAmountError(
          `Maximum SIP amount allowed for this Goal is ₹${maxSIP}`
        );
      } else if (Number(sipDeficit) > 0 && inputSIPAmount > Number(sipDeficit)) {
        setSipAmountError(
          `Maximum SIP amount allowed for this goal is ₹${sipDeficit}`
        );
      } else {
        setSipAmountError(""); // Clear error if within valid range
      }
    } else if (selectedInvest === "Lump Sum") {
      let minLumpSumAmount = isSelectedFundOption?.BSE_Min_Amt;
      let STP_OUT_Flag_Weekly = isSelectedFundOption?.STP_OUT_Flag_Weekly; // or dynamic value
      let STP_OUT_Flag_Monthly = isSelectedFundOption?.STP_OUT_Flag_Monthly;
      let STP_Minimum_Installment_Number_Monthly =
        isSelectedFundOption?.STP_Minimum_Installment_Number_Monthly;
      let STP_Minimum_Installment_Number_Weekly =
        isSelectedFundOption?.STP_Minimum_Installment_Number_Weekly;
      let STP_Out_Minimum_Amount_Monthly =
        isSelectedFundOption?.STP_Out_Minimum_Amount_Monthly;
      let STP_Out_Minimum_Amount_Weekly =
        isSelectedFundOption?.STP_Out_Minimum_Amount_Weekly;

      if (inputLumpSumAmount < Number(minLumpSumAmount) && inputLumpSumAmount !== "") {
        setLumpSumAmountError(
          "Minimum LumpSum amount allowed for selected fund is ₹" +
          minLumpSumAmount
        );
      }
      else {
        setLumpSumAmountError("");
      }
      if (selectedSTP == "Yes") {
        if (inputStpFreq === "Monthly" && STP_OUT_Flag_Monthly != "Y") {
          setStpFreqError("Monthly STP is not allowed for this fund");
        } else if (inputStpFreq == "Weekly" && STP_OUT_Flag_Weekly != "Y") {
          setStpFreqError("Weekly STP is not allowed for this fund");
        } else {
          setStpFreqError("");
        }

        if (
          inputStpFreq == "Monthly" &&
          inputStpDuration < parseInt(STP_Minimum_Installment_Number_Monthly)
        ) {
          setStpDurationError(
            "Minimum monthly installments allowed are " +
            STP_Minimum_Installment_Number_Monthly
          );
        } else if (
          inputStpFreq == "Weekly" &&
          inputStpDuration * 4 < parseInt(STP_Minimum_Installment_Number_Weekly)
        ) {
          setStpDurationError(
            "Minimum weekly installments allowed are " +
            STP_Minimum_Installment_Number_Weekly
          );
        } else {
          setStpDurationError("");
        }

        if (inputStpFreq == "Monthly") {
          var divisor = inputStpDuration;
        } else if (inputStpFreq == "Weekly") {
          var divisor = inputStpDuration * 4;
        }
        if (inputStpLumpsumAmount > Number(inputLumpSumAmount)) {
          setStpLumpsumAmountError(
            "Amount cannot exceed ₹" + inputLumpSumAmount
          );
        } else if (
          inputStpFreq == "Monthly" &&
          Math.round(inputStpLumpsumAmount / Number(divisor)) <
          STP_Out_Minimum_Amount_Monthly
        ) {
          setStpLumpsumAmountError(
            "Minimum STP amount should be ₹" + STP_Out_Minimum_Amount_Monthly
          );
        } else if (
          inputStpFreq == "Weekly" &&
          Math.round(inputStpLumpsumAmount / Number(divisor)) <
          STP_Out_Minimum_Amount_Weekly
        ) {
          setStpLumpsumAmountError(
            "Minimum STP amount should be ₹" + STP_Out_Minimum_Amount_Weekly
          );
        } else {
          setStpLumpsumAmountError("");
        }
        if (inputStpFund !== "") {
          var monthlyFlag, weeklyFlag;
          var fund_name = inputStpFund;
          for (var i = 0; i < amcNameList.length; i++) {
            if (fund_name == amcNameList[i].fund_name) {
              monthlyFlag = amcNameList[i].STP_IN_Flag_Monthly;
              weeklyFlag = amcNameList[i].STP_IN_Flag_Weekly;
            }
          }
          if (inputStpFreq == "Monthly" && monthlyFlag != "Y") {
            setStpInFundError("Monthly STP is not allowed in this fund");
          } else if (inputStpFreq == "Weekly" && weeklyFlag != "Y") {
            setStpInFundError("Weekly STP is not allowed in this fund");
          } else if (fund_name == selectedSubFundName) {
            setStpInFundError("Cannot start STP in same fund");
          } else {
            setStpInFundError("");
          }
        }

        if (STP_OUT_Flag_Weekly == "Y" || STP_OUT_Flag_Monthly == "Y") {
          setSTPError("");
        } else {
          setSTPError("STP is not allowed for selected fund");
        }
      }
      // if (inputStpFreq == "Monthly" && monthlyFlag != "Y")
      console.log(
        "cc",
        STP_Minimum_Installment_Number_Monthly
      );
    } else {
      setSTPError("");
      setLumpSumAmountError('')
      setSipAmountError(""); // Clear error if no input or fund option
      setLumpSumAmountError("");
    }
  }, [
    inputStp,
    inputStpFund,
    inputSIPAmount,
    inputLumpSumAmount,
    inputStpFreq,
    inputStpDuration,
    inputStpLumpsumAmount,
    isSelectedFundOption,
    defSIP,
  ]);

  useEffect(() => {
    if (show) {
      getAMCFundList();
    }
  }, [show]);

  // DeficitAmount
  const calculateDeficitAmount = (data) => {
    let monthEndValue = 0;
    let capitalGrowth = 0;
    let expectedReturn = parseInt(isFiltered.expectedReturn);
    let sipAmount = parseInt(data.sipAmount);
    let goalYear = parseInt(isFiltered.goalYear);
    let initialTotalMonth = (goalYear - new Date().getFullYear()) * 12;
    if (data.prepetualSIP === "Yes") {
      for (let i = 1; i < initialTotalMonth; i++) {
        capitalGrowth = ((monthEndValue + sipAmount) * expectedReturn) / 1200;
        monthEndValue = monthEndValue + capitalGrowth + sipAmount;
      }
      monthEndValue = monthEndValue + sipAmount;
    } else {
      let diff =
        (new Date(data.sipEndDate).getFullYear() -
          new Date(data.sipStartDate).getFullYear()) *
        12 +
        new Date(data.sipEndDate).getMonth() -
        new Date(data.sipStartDate).getMonth();

      for (let i = 1; i < diff; i++) {
        capitalGrowth = ((monthEndValue + sipAmount) * expectedReturn) / 1200;
        monthEndValue = monthEndValue + capitalGrowth + sipAmount;
      }
      monthEndValue = monthEndValue + data.sipAmount;
    }

    setDeficitAmount(Math.round(monthEndValue));
    return (Math.round(monthEndValue));
  };

  // sipDefit

  // const checkSIPAllowed = (requiredSIP) => {
  //   let num = requiredSIP % 1000;
  //   return num < 500 ? requiredSIP - num + 500 : requiredSIP - num + 1000;
  // };
  const checkSIPAllowed = (requiredSIP) => {
    const maxSIP = isSelectedFundOption?.BSE_Maximum_SIP_Amount;
    // console.log('defSIP2',maxSIP,requiredSIP);

    if (!maxSIP) {
      const sip = parseInt(requiredSIP, 10);
      const remainder = sip % 1000;

      if (remainder < 500) {
        return sip - remainder + 500;
      } else {
        return sip - remainder + 1000;
      }
    } else {

      return requiredSIP;
    }
  };

  useEffect(() => {
    // console.log("defSIP",defSIP);

    checkSIPAllowed(defSIP);
    setSipAmountError("");
    calculateSipDefit();
  }, [defSIP]);

  const calculateSipDefit = () => {
    console.log("defSIP", defSIP);

    if (defSIP && defSIP !== 0) {
      // let defsip = checkSIPAllowed(defSIP);
      // console.log("defSIP",defsip);
      // setDefSIP(defsip);
    } else {
      // console.log("defsip",defsip);

      setDefSIP(0);
    }
  };

  function calculateFutureValue(oneTimeInvestment, annualReturn, years) {
    const r = annualReturn / 100
    const fv = oneTimeInvestment * Math.pow(1 + r, years)
    return fv
  }

  // stepUpImpact

  const calculateStepUpImpact = (data) => {
    let goalYear = parseInt(isFiltered.goalYear);
    let isStepUp = data.annualStepUp;
    let expectedReturn = parseInt(isFiltered.expectedReturn);
    let stepUpAmt = parseInt(data.stepUpAmount);
    // console.log("calculateStepUpImpact data :", data, goalYear);
    if (isStepUp === "Yes") {
      let monthEndValue = 0;
      let sip = 0;
      let capitalGrowth = 0;
      let initialTotalMonth = (goalYear - new Date().getFullYear()) * 12;
      // console.log("goalYear",goalYear,initialTotalMonth);

      for (let i = 1; i < initialTotalMonth; i++) {
        if (stepUpAmt !== 0 && i % 12 === 1 && i !== 1) {
          sip += stepUpAmt;
        }
        capitalGrowth = ((monthEndValue + sip) * expectedReturn) / 1200;
        monthEndValue = monthEndValue + capitalGrowth + sip;
      }

      setStepUpImpact(Math.round(monthEndValue + sip));
    }
  };

  // check mandate type onSubmit first
  const checkMandateType = async (memberId, invUCCCode) => {
    console.log("invUCCCode", invUCCCode);
    try {
      const response = await api.post(
        `advisor/checkMandateType`,
        {
          _id: memberId,
          member_id: roomId,
        }
      );
      return response;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setIsError("!Somethig went wrong");
      } else {
        console.error("Error checking mandate type", error);
      }
      return false;
    }
  };
  const getSubGoalName = async (isClientData, slcard) => {
    console.log('isClientData', isClientData, slcard)
  }



  const getFund =(fundName)=>{
       const selectedFund =  amcNameList.find((item) => item?.fund_name === fundName);
       return selectedFund;
  }
  const onSubmit = async (data) => {


    try {
      // Destructure investor details
      const dataString = data.investorName;


      const values = dataString.split("|");

      const investorName = values[0]?.trim();
      const clientCode = values[1]?.trim();
      const bankName = values[2]?.trim();
      const accountNumber = values[3]?.trim();
      const mandateCode = values[4]?.trim();
      const mandateType = values[5]?.trim();
      const mandateBankName = values[6]?.trim();
      const mandateBankAccount = values[7]?.trim();
      const investorMobile = values[8]?.trim();
      const investorEmail = values[9]?.trim();
      const memberId = values[10]?.trim();
      const mandateStatus = values[11]?.trim();
      const IFSCCode = values?.[12]?.trim();


      // Calculate financial values
      const sipDef = await calculateDeficitAmount(data);
      const sipDe = calculateSipDefit(data);
      console.log('sipDe', sipDe, sipDef, deficitAmount);
      calculateStepUpImpact(data);

      const parts = data.investorName.split("|");

      const InvesterAccountNumber = parts[7];  // 0532000109245380
      const InvesterMobileNumber = parts[8];   // 9284677438
      const InvesterEmail = parts[9];
      const InvesterIFSCCode = parts[12];

      // selectedCard?._id
      // selectedCard?.text
      // Prepare SIP payload

      // Example usage
      const goalYear = isFiltered?.goalYear
      const currentYear = new Date().getFullYear()
      const yearDiff = goalYear - currentYear

      const futureValue = calculateFutureValue(
        parseInt(data.stplumpSumAmount),
        Number(isGetClientGoal?.expectedReturn),
        yearDiff
      )

      console.log(`Final Value: ₹${futureValue.toFixed(2)}`, (selectedInvest === "SIP") ? parseInt(data.sipAmount) : parseInt(data.STPLSAmount), yearDiff, Number(isGetClientGoal?.expectedReturn), Number(sipDef) )
      const allSIPData = {
        uid: "",
        fundName: data.fundName,
        scheme_code:selectedFund?.scheme_code||"",
        goalId: selectedCard?._id,
        subGoalId: subGoalId,
        staticTargetAmount: isFiltered?.TargetAmount,
        client_id: roomId,
        goal_name: subGoalName,
        ucc: clientCode,
        mandateCode,
        mandateType,
        folioNo: "",
        email: InvesterEmail || "",
        mobile: InvesterMobileNumber || "",
        accountNo: InvesterAccountNumber,
        ifsc_code:InvesterIFSCCode,
        sipDeficit: Number(sipDef),
        defSIP,
        goalYear: isFiltered?.goalYear,
        sipAmt: parseInt(data.sipAmount),
        perpetual: data.prepetualSIP,
        startDate: data.sipStartDate,
        endDate: data.sipEndDate || "",
        isStepUp: data.annualStepUp,
        stepUpAmt: parseInt(data.stepUpAmount),
        stepUpImpact,
        investorName,
        productCode: isSelectedFundOption?.amc_code,
        member_id: memberId,
        test:'sip Test'
      };

      // Prepare Lump Sum payload
      const allLumpSumData = {
        uid: "",
        fundName: data.fundName || "",
        scheme_code:selectedFund?.scheme_code||"",
        goalId: selectedCard?._id || "",
        subGoalId: subGoalId,
        staticTargetAmount: isFiltered?.TargetAmount,
        client_id: roomId,
        goal_name: subGoalName,
        ucc: clientCode,
        mandateCode,
        mandateType,
        folioNo: "",
        email: InvesterEmail || "",
        mobile: InvesterMobileNumber || "",
        accountNo: InvesterAccountNumber,
        ifsc_code:InvesterIFSCCode,
        // sipDeficit: sipDef,
        sipDeficit: Math.round(futureValue),
        scheme_code: "",
        goalYear: isFiltered?.goalYear,
        isSTP: data.stp,
        stpFreq: data.stpFrequency,
        stpDuration: data.stpFrequency === "Weekly" ? Number(data.stpDuration) * 4 : Number(data.stpDuration),
        STPLSAmount: data.stplumpSumAmount,
        STPInFund: data.stpfundName,
        STPStartDate: data.stpStartDate,
        investorName,
        productCode: isSelectedFundOption?.amc_code,
        member_id: memberId,
        allUnit: 0,
        numberOfUnit: data.stplumpSumAmount,
        test:'lumpsump'
      };
      console.log("alldata", allSIPData, allLumpSumData);
      if (selectedInvest === "SIP") {
        const isMandateValid = await checkMandateType(
          memberId,
          clientCode,
          investorName,
          data,
          mandateCode
        );

        console.log("isMandateValid", isMandateValid);

        if (isMandateValid.data.Status === 400) {
          return Swal.fire({
            title: "Mandate Error",
            text: isMandateValid.data.message || "Invalid mandate. Cannot proceed with SIP.",
            icon: "error",
            customClass: {
              confirmButton: "swal-confirm-btn",
              cancelButton: "swal-cancel-btn",
            },
          });
        }

        if (!mandateCode) {
          // Mandate not registered
          const result = await Swal.fire({
            title: "Client has no approved mandate",
            text: "SIP will start after mandate registration. Proceed?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, proceed",
            cancelButtonText: "No, cancel",
            customClass: {
              confirmButton: "swal-confirm-btn",
              cancelButton: "swal-cancel-btn",
            },
          });

          if (!result.isConfirmed) return;
        }

        // Proceed with SIP submission
        await handleSIPSubmission(allSIPData);
        reset();
        onHide();
        setInvestString([]);
        getDraftGoalData()
      } else if (selectedInvest === "Lump Sum") {
        try {
          const response = await api.post(
            `advisor/lumpsum_start`,
            allLumpSumData
          );

          // If response is success and no error in payload
          if (response.data?.status !== "error") {
            console.log("✅ Lump Sum API Response:", response);

            Swal.fire({
              title: "Success",
              text: "Lump Sum process started successfully!",
              icon: "success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            });

            reset();
            onHide();
            setInvestString([]);
            getDraftGoalData();
          } else {
            // Backend responded with an error (like amountDeficit)
            Swal.fire({
              title: "Insufficient Amount",
              text: `You have a shortfall of ₹${response.data.amountDeficit.toLocaleString("en-IN")}`,
              icon: "warning",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            });
          }
        } catch (error) {
          console.error("❌ Error in lumpsum_start API:", error);

          const errorMessage =
            error.response?.data?.message ||
            "Something went wrong while starting Lump Sum process.";

          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          });
        }


      }

    } catch (error) {
      console.error("Error in onSubmit:", error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong while processing your request.",
        icon: "error",
        customClass: {
          confirmButton: "swal-confirm-btn",
          cancelButton: "swal-cancel-btn",
        },
      });
    }
  };

  // Helper to submit SIP used in onsubmit
  const handleSIPSubmission = async (sipData) => {
    try {
      const response = await api.post(
        `advisor/sip_start`,
        sipData
      );
      console.log("SIP API Response:", response);

      setSIPSuccess(true);
      Swal.fire({
        title: "Success",
        text: "SIP process started successfully!",
        icon: "success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
    } catch (error) {
      console.error("SIP Submission Error:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to start SIP process.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (!show) {
      reset();
    }
  }, [show, reset]);

  // Fetch AMC fund list from API
  const getAMCFundList = async () => {
    if (amcName.length > 0) return; // Avoid re-calling if already fetched
    setIsLoadingAMC(true);
    try {
      const response = await api.get(
        `advisor/master_amc_fund_list`
      );
      setAmcFundList(response.data || []);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    } finally {
      setIsLoadingAMC(false);
    }
  };

  // Fetch AMC fund names based on selected fund (investmentType)
  const getAMCFundName = async (fundName) => {
    try {
      const response = await api.get(
        `advisor/amc_fund_by_house?house_name=${fundName}`
      );
      setAmcNameList(response.data);
    } catch (error) {
      console.error("Error fetching AMC fund names:", error);
    }
  };

  // When the investmentType changes, get AMC Fund Name
  useEffect(() => {
    if (selectedFund) {
      getAMCFundName(selectedFund);
    }
  }, [selectedFund]);

  const handleFundName = (e) => {
    const selectedOption = amcNameList.find(
      (item) => item?.fund_name === e.target.value
    );
    console.log("handleFundName", selectedOption);
    setSipAllowedDate(selectedOption?.SIP_Dates_Allowed)
    setSTPFrequencyAllowed(selectedOption?.STP_Frequency_Allowed)
    setSelectedFundOption(selectedOption);
    const currentMinSIPAmount = Number(selectedOption?.BSE_Minimum_SIP_Amount);
    const currentMaxSIPAmount = Number(selectedOption?.BSE_Maximum_SIP_Amount);
    console.log('currentMaxSIPAmount', currentMaxSIPAmount)
    const sipAmt = parseInt(inputSIPAmount);
    // console.log("sipAmt", sipAmt);
    const fName = selectedOption?.fund_name;
    // console.log("fName",fName,sipAmt);
    const updatedInvestString = [...investString];
    updatedInvestString[2] = ` in ${fName}`;
    setInvestString(updatedInvestString);

    if (sipAmt < currentMinSIPAmount) {
      setSipAmountError(
        `Minimum SIP amount allowed for selected fund is ₹${currentMinSIPAmount}`
      );
    } else if (sipAmt > currentMaxSIPAmount) {
      const sipDefit = checkSIPAllowed(defSIP);
      if (sipDefit > 0) {
        setSipAmountError(
          `Maximum SIP amount allowed for this goal is ₹${sipDefit}`
        );
      } else {
        setSipAmountError(
          `Maximum SIP amount allowed for this goal is ₹${currentMaxSIPAmount}`
        );
      }
    } else {
      setSipAmountError("");
    }
  };


  useEffect(() => {
    if (bankDetails.length > 0) {
      const defaultInvestor = [
        bankDetails[0].name,
        bankDetails[0].clientCode,
        bankDetails[0].bankName,
        bankDetails[0].accountNumber,
        bankDetails[0].mandateCode,
        bankDetails[0].mandateType,
        bankDetails[0].mandateBankName,
        bankDetails[0].mandateBankAccount,
        bankDetails[0].mobile,
        bankDetails[0].email,
        bankDetails[0].member_id,
        bankDetails[0].mandateStatus,
        bankDetails[0].ifsc_code,

      ].join("|");

      setValue("investorName", defaultInvestor); // ✅ from react-hook-form
    }
  }, [bankDetails]);


  const filterSIPDates = (date) => {
    if (selectedInvest !== "SIP") return true; // ✅ Allow all dates for non-SIP investments

    // 🧠 Handle empty or invalid cases
    if (
      !sipAllowedDate ||
      sipAllowedDate.length === 0 ||
      sipAllowedDate === "[]"
    ) {
      return true;
    }

    // ✅ Normalize both date and allowed array
    const day = String(date.getDate()).padStart(2, "0");

    // Convert all allowed days into "01", "02", "03" format for uniform matching
    const normalizedAllowed = sipAllowedDate.map((d) =>
      String(d).padStart(2, "0")
    );

    console.log("date:", day, date, normalizedAllowed);

    return normalizedAllowed.includes(day);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <FundDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        content={modalContent}
      />
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#23674b", border: "none", color: "#fff" }}
        closeVariant="white"
      >
        <Modal.Title>
          <p style={{ fontSize: "14px", font: "bold" }}>START INVESTMENT</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* <SectionHeader title={isLabel} /> */}
          <SectionHeader title={actionName} />

          {/* Investor Name */}
          <Form.Group className="mb-3">
            <Form.Label>Investor Name</Form.Label>
            <Form.Select

              {...register("investorName", {
                required: "Investor name is required",
              })}
            >
              {/* <option value="">Select Investor</option> */}

              {bankDetails.length === 1 &&
                bankDetails[0].mandateStatus !== "inactive" ? (
                <option
                  value={[
                    bankDetails[0].name,
                    bankDetails[0].clientCode,
                    bankDetails[0].bankName,
                    bankDetails[0].accountNumber,
                    bankDetails[0].mandateCode,
                    bankDetails[0].mandateType,
                    bankDetails[0].mandateBankName,
                    bankDetails[0].mandateBankAccount,
                    bankDetails[0].mobile,
                    bankDetails[0].email,
                    bankDetails[0].member_id,
                    bankDetails[0].mandateStatus,
                    bankDetails[0].ifsc_code,
                  ].join("|")}
                >
                  {bankDetails[0].name}
                </option>
              ) : (
                bankDetails.map((detail, index) => (
                  <option
                    key={index}
                    value={[
                      detail.name,
                      detail.clientCode,
                      detail.bankName,
                      detail.accountNumber,
                      detail.mandateCode,
                      detail.mandateType,
                      detail.mandateBankName,
                      detail.mandateBankAccount,
                      detail.mobile,
                      detail.email,
                      detail.member_id,
                      detail.mandateStatus,
                      detail.ifsc_code,
                    ].join("|")}
                  >
                    {detail.name}
                  </option>
                ))
              )}
            </Form.Select>

            {errors.investorName && (
              <p style={{ color: "red" }}>{errors.investorName.message}</p>
            )}
          </Form.Group>

          {/* Investor Name */}
          <Form.Group className="mb-3">
            <Form.Label>Invest</Form.Label>
            <Form.Select
              {...register("invest", {
                required: "Invest is required",
              })}
            >
              <option value="">Select Invest</option>
              <option value="SIP">SIP</option>
              <option value="Lump Sum">Lump Sum</option>
            </Form.Select>
            {errors.invest && (
              <p style={{ color: "red" }}>{errors.invest.message}</p>
            )}
          </Form.Group>
          {selectedInvest === "SIP" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>SIP Amount</Form.Label>
                <Form.Control
                  {...register("sipAmount", {
                    required: true,
                  })}
                // onChange={(e)=>setIsSipAmount(e.target.value)}
                />

                {errors.sipAmount && (
                  <span style={{ color: "red" }}>SIP amount is required</span>
                )}
                {sipAmountError && (
                  <div id="sipAmountError" style={{ color: "red" }}>
                    {sipAmountError}
                  </div>
                )}
              </Form.Group>

              {/* Select AMC Fund */}
              <Form.Group className="mb-3">
                <Form.Label>AMC Name</Form.Label>
                <Form.Select
                  // onFocus={getAMCFundList}
                  {...register("investmentType", {
                    required: "Investment type is required",
                  })}
                >
                  <option value={""}>Select</option>
                  {isLoadingAMC ? (
                    <option disabled>Loading AMC list...</option>
                  ) : (
                    <>
                      {/* Whitelisted Group */}
                      <optgroup label="Whitelisted">
                        {Object.values(amcName)
                          .filter((item) => item.Whitelisted === "true") // Check as string since it's "true"
                          .map((item, index) => (
                            <option key={index} value={item.fund_house_name}>
                              {item.fund_house_name}
                            </option>
                          ))}
                      </optgroup>

                      {/* Non-Whitelisted Group */}
                      <optgroup label="Non-Whitelisted">
                        {Object.values(amcName)
                          .filter((item) => item.Whitelisted === "false")
                          .map((item, index) => (
                            <option key={index} value={item.fund_house_name}>
                              {item.fund_house_name}
                            </option>
                          ))}
                      </optgroup>
                    </>
                  )}
                </Form.Select>
                {errors.amcName && (
                  <p style={{ color: "red" }}>{errors.amcName.message}</p>
                )}
              </Form.Group>

              {amcNameList.length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label>Fund Name</Form.Label>
                  <Form.Select
                    {...register("fundName", {
                      required: "Fund Name is required",
                    })}
                    onChange={handleFundName}
                  >
                    <>
                      <option value={""}>Select</option>
                      {/* Whitelisted Group */}
                      <optgroup label="Whitelisted">
                        {amcNameList
                          .filter((item) => item.Whitelisted === "true") // Check as string since it's "true"
                          .map((item, index) => (
                            <option key={index} value={item.fund_name}>
                              {item.fund_name}
                            </option>
                          ))}
                      </optgroup>

                      {/* Non-Whitelisted Group */}
                      <optgroup label="Non-Whitelisted">
                        {Object.values(amcNameList)
                          .filter((item) => item.Whitelisted === "false")
                          .map((item, index) => (
                            <option key={index} value={item.fund_name}>
                              {item.fund_name}
                            </option>
                          ))}
                      </optgroup>
                    </>
                  </Form.Select>
                  {errors.fundName && (
                    <p style={{ color: "red" }}>{errors.fundName.message}</p>
                  )}
                </Form.Group>
              )}

              {/* SIP Start Date */}
              {/* <Form.Group className="mb-3">
                <Form.Label>SIP Start Date</Form.Label>
                <br />
                <DatePicker
                  selected={watch("sipStartDate")}
                  onChange={(date) => setValue("sipStartDate", date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  minDate={new Date()}
                />
                {errors.sipStartDate && (
                  <p style={{ color: "red" }}>{errors.sipStartDate.message}</p>
                )}
              </Form.Group> */}
              {/*  SIP Start date */}
              <Form.Group className="mb-3">
                <Form.Label>SIP Start Date</Form.Label>
                <div className="position-relative">
                  <DatePicker
                    selected={watch("sipStartDate")}
                    onChange={(date) => setValue("sipStartDate", date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="SIP Start Date"
                    className="form-control w-100 px-4"
                    minDate={new Date(new Date().setDate(new Date().getDate() + 2))}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    ref={sipStartDatePickerRef}
                    filterDate={filterSIPDates}
                  />

                  {/* Calendar Icon inside input */}
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y px-3 text-muted"
                    style={{ cursor: "pointer" }}
                    onClick={() => sipStartDatePickerRef.current.setOpen(true)}
                  >
                    <FaCalendarAlt />
                  </span>
                </div>
              </Form.Group>

              {/* Prepetual SIP */}
              <Form.Group className="mb-3">
                <Form.Label>Prepetual SIP ?</Form.Label>
                <Form.Select
                  defaultValue="Yes"
                  {...register("prepetualSIP", {
                    required: "Prepetual SIP is required",
                  })}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
                {errors.prepetualSIP && (
                  <p style={{ color: "red" }}>{errors.prepetualSIP.message}</p>
                )}
              </Form.Group>

              {selectedPrepetualType === "Yes" && (
                <Form.Group className="mb-3">
                  <Form.Label>Anual Step Up ?</Form.Label>
                  <Form.Select
                    {...register("annualStepUp", {
                      required: "Anmual Step Up is required",
                    })}
                    defaultValue="No"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                  {errors.annualStepUp && (
                    <p style={{ color: "red" }}>
                      {errors.annualStepUp.message}
                    </p>
                  )}
                </Form.Group>
              )}

              {selectedPrepetualType === "No" && (
                <Form.Group className="mb-3">
                  <Form.Label>SIP End Date</Form.Label>
                  <br />
                  <div className="position-relative">
                    <DatePicker
                      className="form-control"
                      placeholderText="Select Date"
                      selected={watch("sipEndDate")}
                      dateFormat="dd-MM-yyyy"
                      onChange={(date) => setValue("sipEndDate", date)}
                      // onChange={(date) => field.onChange(date)}
                      // selected={field.value}
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={50}
                      minDate={
                        new Date(new Date().setDate(new Date().getDate() + 2))
                      } // Set the minimum selectable date to today
                      ref={endDatePickerRef}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y px-3 text-muted"
                      style={{ cursor: "pointer" }}
                      onClick={() => endDatePickerRef.current.setOpen(true)}
                    >
                      <FaCalendarAlt />
                    </span>
                  </div>
                  {errors.sipEndDate && (
                    <p style={{ color: "red" }}>{errors.sipEndDate.message}</p>
                  )}
                </Form.Group>
              )}

              {selectedPrepetualType === "Yes" &&
                selectedAnnualStepUp === "Yes" && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Step Up Amount</Form.Label>
                      <Form.Control
                        {...register("stepUpAmount", {
                          required: "Step Up Amount is required",
                        })}
                      />

                      {errors.stepUpAmount && (
                        <p style={{ color: "red" }}>
                          {errors.stepUpAmount.message}
                        </p>
                      )}
                    </Form.Group>
                  </>
                )}
            </>
          )}

          {/* Lump Sum  Start  */}
          {selectedInvest === "Lump Sum" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Lump Sum Amount</Form.Label>
                <Form.Control
                  {...register("lumpSumAmount", {
                    required: "Lump Sum Amount is required",
                  })}
                />

                {errors.lumpSumAmount && (
                  <p style={{ color: "red" }}>{errors.lumpSumAmount.message}</p>
                )}
                {lumpSumAmountError && (
                  <div id="lumpSumAmountError" style={{ color: "red" }}>
                    {lumpSumAmountError}
                  </div>
                )}
              </Form.Group>

              {/* Select AMC Fund */}
              <Form.Group className="mb-3">
                <Form.Label>AMC Name</Form.Label>
                <Form.Select
                  {...register("investmentType", {
                    required: "Investment type is required",
                  })}
                >
                  <option value={""}>Select</option>
                  {/* Whitelisted Group */}
                  <optgroup label="Whitelisted">
                    {Object.values(amcName)
                      .filter((item) => item.Whitelisted === "true") // Check as string since it's "true"
                      .map((item, index) => (
                        <option key={index} value={item.fund_house_name}>
                          {item.fund_house_name}
                        </option>
                      ))}
                  </optgroup>

                  {/* Non-Whitelisted Group */}
                  <optgroup label="Non-Whitelisted">
                    {Object.values(amcName)
                      .filter((item) => item.Whitelisted === "false")
                      .map((item, index) => (
                        <option key={index} value={item.fund_house_name}>
                          {item.fund_house_name}
                        </option>
                      ))}
                  </optgroup>
                </Form.Select>
                {errors.amcName && (
                  <p style={{ color: "red" }}>{errors.amcName.message}</p>
                )}
              </Form.Group>

              {amcNameList.length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label>Fund Name</Form.Label>
                  <Form.Select
                    {...register("fundName", {
                      required: "Fund Name is required",
                    })}
                    onChange={handleFundName}
                  >
                    <>
                      <option value={""}>Select Fund Name</option>
                      {/* Whitelisted Group */}
                      <optgroup label="Whitelisted">
                        {Object.values(amcNameList)
                          .filter((item) => item.Whitelisted === "true") // Check as string since it's "true"
                          .map((item, index) => (
                            <option key={index} value={item.fund_name}>
                              {item.fund_name}
                            </option>
                          ))}
                      </optgroup>

                      {/* Non-Whitelisted Group */}
                      <optgroup label="Non-Whitelisted">
                        {Object.values(amcNameList)
                          .filter((item) => item.Whitelisted === "false")
                          .map((item, index) => (
                            <option key={index} value={item.fund_name}>
                              {item.fund_name}
                            </option>
                          ))}
                      </optgroup>
                    </>
                  </Form.Select>
                  {errors.fundName && (
                    <p style={{ color: "red" }}>{errors.fundName.message}</p>
                  )}
                </Form.Group>
              )}

              {/* + STP? */}
              {amcNameList.length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label>+ STP ?</Form.Label>
                  <Form.Select
                    {...register("stp", {
                      required: "STP is required",
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                  {errors.stp && (
                    <p style={{ color: "red" }}>{errors.stp.message}</p>
                  )}

                  {stpError && <p style={{ color: "red" }}>{stpError}</p>}
                </Form.Group>
              )}
              {stpError === "" && selectedSTP === "Yes" && (
                <>
                  {/* STP Frequency */}
                  <Form.Group className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>STP Frequency</Form.Label>
                      <Form.Select
                        {...register("stpFrequency", {
                          required: "STP Frequency is required",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                      </Form.Select>
                      {errors.stpFrequency && (
                        <p style={{ color: "red" }}>
                          {errors.stpFrequency.message}
                        </p>
                      )}
                      {stpFreqError && (
                        <div id="stpFreqError" style={{ color: "red" }}>
                          {stpFreqError}
                        </div>
                      )}
                    </Form.Group>
                    {/* <Form.Label>STP Frequency</Form.Label>

                    <Form.Select
                      {...register("stpFrequency", {
                        required: "STP Frequency is required",
                      })}
                    >
                      <option value="">Select</option>

                      {(() => {
                        // 🧠 Parse stringified array if needed
                        let allowed = [];
                        try {
                          allowed = JSON.parse(stpFrequencyAllowed || "[]");
                        } catch (e) {
                          console.warn("Invalid stpFrequencyAllowed:", e);
                          allowed = [];
                        }

                        // 🧩 If empty → default to ["Weekly", "Monthly"]
                        if (!allowed || allowed.length === 0) {
                          allowed = ["Weekly", "Monthly"];
                        }

                        return allowed.map((freq) => (
                          <option key={freq} value={freq}>
                            {freq}
                          </option>
                        ));
                      })()}
                    </Form.Select> */}

                    {errors.stpFrequency && (
                      <p style={{ color: "red" }}>{errors.stpFrequency.message}</p>
                    )}
                    {stpFreqError && (
                      <div id="stpFreqError" style={{ color: "red" }}>
                        {stpFreqError}
                      </div>
                    )}
                  </Form.Group>

                  {/* STP Duration (Months) */}
                  <Form.Group className="mb-3">
                    <Form.Label>STP Duration ({inputStpFreq})</Form.Label>
                    <Form.Control
                      {...register("stpDuration", {
                        required: "STP Duration is required",
                      })}
                    />

                    {errors.stpDuration && (
                      <p style={{ color: "red" }}>
                        {errors.stpDuration.message}
                      </p>
                    )}
                    {stpDurationError && (
                      <div id="stpDurationError" style={{ color: "red" }}>
                        {stpDurationError}
                      </div>
                    )}
                  </Form.Group>

                  {/*Lump Sum Amount */}
                  <Form.Group className="mb-3">
                    <Form.Label>Lump Sum Amount</Form.Label>
                    <Form.Control
                      {...register("stplumpSumAmount", {
                        required: "Lump Sum Amount is required",
                      })}
                    />

                    {errors.stplumpSumAmount && (
                      <p style={{ color: "red" }}>
                        {errors.stplumpSumAmount.message}
                      </p>
                    )}
                    {stpLumpsumAmountError && (
                      <p style={{ color: "red" }}>{stpLumpsumAmountError}</p>
                    )}
                  </Form.Group>

                  {/* <Form.Group className="mb-3">
                    <Form.Label>Select STP In Fund</Form.Label>
                    <Form.Select
                      {...register("stpFund", {
                        required: "STP In Fund is required",
                      })}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                    {errors.stpFund && (
                      <p style={{ color: "red" }}>{errors.stpFund.message}</p>
                    )}
                  </Form.Group> */}

                  {amcNameList.length > 0 && (
                    <Form.Group className="mb-3">
                      <Form.Label>Select STP In Fund</Form.Label>
                      <Form.Select
                        {...register("stpfundName", {
                          required: "STP In Fund is required",
                        })}
                      // onChange={handleFundName}
                      >
                        <>
                          <option value={""}>Select</option>
                          {/* Whitelisted Group */}
                          <optgroup label="Whitelisted">
                            {Object.values(amcNameList)
                              .filter((item) => item.Whitelisted === "true") // Check as string since it's "true"
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item.fund_name}
                                  disabled={
                                    item.fund_name === selectedSubFundName
                                  }
                                >
                                  {item.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          {/* Non-Whitelisted Group */}
                          <optgroup label="Non-Whitelisted">
                            {Object.values(amcNameList)
                              .filter((item) => item.Whitelisted === "false")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item.fund_name}
                                  disabled={
                                    item.fund_name === selectedSubFundName
                                  }
                                >
                                  {item.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.stpfundName && (
                        <p style={{ color: "red" }}>
                          {errors.stpfundName.message}
                        </p>
                      )}
                      {stpInFundError && (
                        <p style={{ color: "red" }}>{stpInFundError}</p>
                      )}
                    </Form.Group>
                  )}

                  {/* SIP Start Date */}
                  <Form.Group className="mb-3">
                    <Form.Label>STP Start Date</Form.Label>

                    <Controller
                      control={control}
                      name="stpStartDate"
                      rules={{ required: "Start date is required" }}
                      render={({ field }) => {
                        const today = new Date();
                        const delayDays = mandateStatus === "active" ? 7 : 7;
                        const minSelectableDate = new Date(
                          today.setDate(today.getDate() + delayDays)
                        );

                        return (
                          <div className="position-relative">
                            <DatePicker
                              className="form-control w-100 px-4"
                              placeholderText="Select Date"
                              dateFormat="dd-MM-yyyy"
                              onChange={field.onChange}
                              selected={field.value}
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={50}
                              minDate={minSelectableDate}
                              ref={stpStartDatePickerRef}
                            />
                            {/* Calendar Icon */}
                            <span
                              className="position-absolute top-50 end-0 translate-middle-y px-3 text-muted"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                stpStartDatePickerRef.current?.setOpen(true)
                              }
                            >
                              <FaCalendarAlt />
                            </span>
                          </div>
                        );
                      }}
                    />
                    {errors.stpStartDate && (
                      <p style={{ color: "red" }}>
                        {errors.stpStartDate.message}
                      </p>
                    )}
                  </Form.Group>
                </>
              )}
            </>
          )}
          <></>
        </Form>
      </Modal.Body>
      <Modal.Footer className=" flex-nowrap  justify-content-between">
        <p className="text-danger">{isError}</p>

        <button
          className="lrgbutton text-white w-100 text-uppercase"
          onClick={handleSubmit(onSubmit)}
        >
          Initiate
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddNewInvestments;
